import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { byPassJwToken } from './common/interceptor.service';
import { environment } from 'src/environments/environment.prod'
@Injectable({
  providedIn: 'root'
})
export class RememberPasswordService {

  constructor(private http:HttpClient) { }

  // remember(user:string,ambiente:any){
  //   return this.http.get(environment.urlSesio+'/pwd/'+user+'/'+ambiente )
  // }

  // remeberPassword(token:any,data:any){
  //   return this.http.post(environment.urlSesio+'/pwd?tkn='+token,data);
  // }
  // remeberUser(ambiente:any,email:any){
  //   return this.http.get(environment.urlSesio+'/usr/'+ambiente+'?email='+email);
  // }
}
